import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useBackButtonHandler = (callback: () => void) => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {

    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault();
      if (window.confirm("Вы действительно хотите уйти?")) {
        navigate(-1);
      } else {
        window.history.pushState(null, "", location.pathname);
      }
      callback()
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate, location]);

}